import { Injectable, inject, ApplicationRef, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter, first } from 'rxjs/operators';
import { interval, concat } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { UpdateAvailableDialogComponent } from './update-available-dialog.component';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly appRef = inject(ApplicationRef);
  private readonly dialog = inject(MatDialog);
  private readonly destroyRef = inject(DestroyRef);

  init(): void {
    if (!this.swUpdate.isEnabled) return;

    // Verificar actualizaciones cada 2 minutos después de que la app esté estable
    const appIsStable$ = this.appRef.isStable.pipe(first(stable => stable));
    const everyTwoMinutes$ = interval(2 * 60 * 1000);
    concat(appIsStable$, everyTwoMinutes$).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.swUpdate.checkForUpdate().catch(() => {});
    });

    // Escuchar cuando una nueva versión está lista
    this.swUpdate.versionUpdates.pipe(
      filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.showUpdateDialog();
    });
  }

  private showUpdateDialog(): void {
    const dialogRef = this.dialog.open(UpdateAvailableDialogComponent, {
      disableClose: true,
      width: '400px',
      panelClass: 'update-dialog-panel'
    });

    dialogRef.afterClosed().subscribe((shouldUpdate: boolean) => {
      if (shouldUpdate) {
        document.location.reload();
      }
    });
  }
}
